module.exports = __webpack_public_path__ + "img/card-FMCG4.f8560a49.svg";